"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withPartials;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _immutable = _interopRequireDefault(require("immutable"));

function withPartials(WrappedComponent) {
  var HighOrderWithPartials =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(HighOrderWithPartials, _Component);

    function HighOrderWithPartials(props) {
      var _this;

      (0, _classCallCheck2.default)(this, HighOrderWithPartials);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(HighOrderWithPartials).call(this, props));
      _this.partial = _this.partial.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(HighOrderWithPartials, [{
      key: "UNSAFE_componentWillMount",
      value: function UNSAFE_componentWillMount() {
        this._partials = _immutable.default.Map();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this._partials = null;
      }
    }, {
      key: "partial",
      value: function partial(func) {
        var _Immutable$List;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        (0, _invariant.default)(typeof func === 'function', '%s.partial: expected `func` to be a function but got `%s`.', (0, _getComponentName.default)(WrappedComponent), func);

        var keyList = (_Immutable$List = _immutable.default.List).of.apply(_Immutable$List, [func].concat(args));

        if (!this._partials.has(keyList)) {
          this._partials = this._partials.set(keyList, function () {
            for (var _len2 = arguments.length, partialArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              partialArgs[_key2] = arguments[_key2];
            }

            return func.apply(void 0, args.concat(partialArgs));
          });
        }

        return this._partials.get(keyList);
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement(WrappedComponent, (0, _extends2.default)({}, this.props, {
          partial: this.partial
        }));
      }
    }]);
    return HighOrderWithPartials;
  }(_react.Component);

  return HighOrderWithPartials;
}

module.exports = exports.default;